<!-- Filter Modal Backdrop -->
<div
  *ngIf="isVisible"
  class="modal-backdrop"
  (click)="onBackdropClick($event)"
  role="dialog"
  aria-modal="true"
  aria-labelledby="filter-modal-title"
>
  <!-- Filter Modal -->
  <div class="filter-modal" (click)="$event.stopPropagation()">
    <!-- Modal Header -->
    <div class="modal-header">
      <div class="header-content">
        <h2 id="filter-modal-title" class="modal-title">Filters</h2>
        <button class="close-button" (click)="onClose()" aria-label="Close filter modal">
          <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9 3L3 9M3 3L9 9"
              stroke="#555963"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>

    <!-- Modal Content -->
    <div class="modal-content">
      <div class="filters-container">
        <!-- Service Filter -->
        <div class="filter-section">
          <h3 class="filter-title">Service</h3>
          <div class="filter-options">
            <div *ngIf="services.length === 0" class="no-service-message">
              Service not available
            </div>
            <div class="filter-row">
              <div *ngFor="let service of services; trackBy: trackByIndex" class="checkbox-item">
                <app-checkbox [(checked)]="service.checked" [label]="service.label"></app-checkbox>
              </div>
            </div>
          </div>
        </div>

        <!-- Employee Filter - Only for Admin -->
        <div class="filter-section" *ngIf="isAdminUser">
          <h3 class="filter-title">Employee</h3>
          <div class="filter-options">
            <div class="filter-row">
              <div
                *ngFor="let employee of getDisplayedEmployees(); trackBy: trackByIndex"
                class="checkbox-item"
              >
                <app-checkbox
                  [(checked)]="employee.checked"
                  [label]="employee.label"
                ></app-checkbox>
              </div>
            </div>

            <!-- Show More / Show Less Text -->
            <div *ngIf="employees.length > employeeDisplayLimit" class="show-more-wrapper">
              <span class="show-more-text" (click)="toggleShowAllEmployees()">
                {{
                  showAllEmployees ? 'Show less' : 'Show all (' + getRemainingEmployeesCount() + ')'
                }}
              </span>
            </div>
          </div>
        </div>

        <!-- Location Filter - Only for Admin -->
        <div class="filter-section" *ngIf="isAdminUser">
          <h3 class="filter-title">Location</h3>
          <div class="filter-options">
            <div class="filter-row">
              <div *ngFor="let location of locations; trackBy: trackByIndex" class="checkbox-item">
                <app-checkbox
                  [(checked)]="location.checked"
                  [label]="location.label"
                ></app-checkbox>
              </div>
            </div>
          </div>
        </div>

        <!-- Status Filter -->
        <div class="filter-section">
          <h3 class="filter-title">Status</h3>
          <div class="filter-options">
            <ng-container
              *ngTemplateOutlet="statusRow; context: { items: statuses.slice(0, 2) }"
            ></ng-container>
            <ng-container
              *ngTemplateOutlet="statusRow; context: { items: statuses.slice(2, 4) }"
            ></ng-container>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Footer -->
    <app-modal-footer-actions
      footerClass="modal-footer"
      secondaryText="Clear Filters"
      primaryText="Apply Filters"
      [secondaryDisabled]="!hasActiveFilters()"
      [cancelDesktopOnly]="true"
      (secondaryClick)="onClearFilters()"
      (cancelClick)="onCancel()"
      (primaryClick)="onApplyFilters()"
    />
  </div>
</div>

<!-- Status Filter Row Template (reused for each slice of status checkboxes) -->
<ng-template #statusRow let-items="items">
  <div class="filter-row">
    <div *ngFor="let status of items; trackBy: trackByIndex" class="checkbox-item">
      <app-checkbox [(checked)]="status.checked" [label]="status.label"></app-checkbox>
    </div>
  </div>
</ng-template>
